<div class="icon-container">
  <fa-icon [icon]="iconName"></fa-icon>
</div>

<h6 class="list-not-found__headline mb-2">
  {{ header }}
</h6>
<p class="list-not-found__subheading">
  {{ message }}
</p>
